export default Object.freeze({
  User: 1,
  ProcessInstance: 2,
  App: 3,
  Entity: 4,
  Process: 5,
  List: 6,
  Agent: 7,
});
